"use client"

import { useRouter } from "next/navigation"
import Script from "next/script"
import { addToast } from "@heroui/toast"
import { signIn, useSession } from "next-auth/react"

export default function GoogleOneTap() {
  const { refresh } = useRouter()

  const handleCallback = (response: { credential: string }) =>
    signIn("google-one-tap", {
      credential: response.credential,
      redirect: false,
    })
      .then(function () {
        addToast({
          title: "Signed in successfully",
          description: "You have been signed in successfully",
          color: "success",
          icon: "check",
          timeout: 3000,
        })
        refresh()
      })
      .catch(function () {
        addToast({
          title: "Error signing in",
          description: "Please try again",
          color: "danger",
          icon: "x",
          timeout: 3000,
        })
      })

  useSession({
    required: true,
    onUnauthenticated: () => {
      if (window?.google?.accounts?.id) {
        window.google.accounts.id.initialize({
          client_id: process.env.NEXT_PUBLIC_AUTH_GOOGLE_ID!,
          callback: handleCallback,
        })
        window.google.accounts.id.prompt()
      }
    },
  })

  return <Script src="https://accounts.google.com/gsi/client" />
}
